<!--
 * @Author: Ashley.Liu
 * @Date: 2022-05-05 16:12:18
 * @LastEditTime: 2022-06-29 13:13:26
 * @Description: desc
-->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>
